export function shouldShowTurnitinEula(userOrPayload) {
  if (!userOrPayload || userOrPayload.showEula == null) {
    return false;
  }

  const { showEula } = userOrPayload;
  return showEula === true || showEula === 1 || showEula === '1';
}
